import { Component, OnDestroy, OnInit } from '@angular/core';
import { EMPTY } from 'rxjs';
import { take, switchMap } from 'rxjs/operators';
import { TipoServicoApiService } from 'app/api/tipoServicoApi.service';
import { TipoServico } from 'app/model/tipoServico';
import { AlertModalService } from 'app/shared/alert-modal.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-tiposervico',
  templateUrl: './tiposServicos.component.html',
  styleUrls: ['./tiposServicos.component.css']
})
export class TiposServicosComponent implements OnInit, OnDestroy {

  tipoServico: TipoServico[];

  private subs = new SubSink();

  constructor(
    private tiposServicosService: TipoServicoApiService,
    private alertService: AlertModalService) { }

  ngOnInit() {
    this.getTipoServico();
  }

  onDelete(servico: TipoServico) {

    const result$ = this.alertService.showConfirm('Confirmação', 'Tem certeza que deseja excluir esse Tipo de Serviço?');
    result$.asObservable()
    .pipe(
      take(1),
      switchMap(result => result ? this.tiposServicosService.v1TiposervicoTipoServicoIdDelete(servico.id) : EMPTY)
    )
    .subscribe(
      success => {
        this.alertService.showAlertSuccess('Tipo de Serviço excluído com sucesso!');
        // this.ngOnInit();
        this.getTipoServico();
      },
      error => {
        console.error("Erro:", error);
        if (error?.Erros && Array.isArray(error.Erros) && error.Erros.length > 0) {
          this.alertService.showAlertDanger(error.Erros[0].Mensagem);
        } else {
          this.alertService.showAlertDanger('Erro ao excluir o Tipo de Serviço. Tente novamente mais tarde.');
        }
        // this.alertService.showAlertDanger('Erro ao excluir o Tipo de Serviço. Tente novamente mais tarde.');
      }
    );
  }

  private getTipoServico(): void {
    this.subs.sink = this.tiposServicosService.v1TiposervicoGet()
    .subscribe(
        tipoServico => {
        return this.tipoServico = tipoServico;
      });
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

}
